var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46.621 50.243",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-182.46 1.0521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 29.655,
    r: 17.036,
    fill: "none",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.57352 0 0 .52306 143.34 -36.91)",
    d: "m102.28 80.421c-3.1872.03888-6.42.25322-6.42.25322-.0306-1.4575.34463-4.4228-4.3403-4.4043h-3.3839v-5.83h14.123l14.123-.05879.0243 5.83-3.3839.01408c-4.6849.00096-4.2974 2.9647-4.3219 4.4223 0 0-3.2337-.20089-6.421-.2265z",
    stopColor: "#000000",
    strokeWidth: 3.6516
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(102.35 -65.731)",
    d: "m119.87 80.112c-1.9399-2.5939-3.3028-3.1568-3.0001-3.4107 1.2004-1.0067 3.2074-2.6128 3.2074-2.6128l2.8103 3.7275 2.843 3.7026s-2.0831 1.506-3.3735 2.3944c-.32546.22408-.5045-1.2396-2.4871-3.801z",
    stopColor: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202 20.261a9.3943 9.3943 0 018.1357 4.6972 9.3943 9.3943 0 01-1e-5 9.3943l-8.1357-4.6972z",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.95a08dd4d44594dd280d0d922419b1fb.svg";
export { ForwardRef as ReactComponent };